module.exports = __webpack_public_path__ + "static/media/react.1a36cc4d.svg";